import type { ProductCardProps } from '@coursera/cds-core';

import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';
import { shouldUseExperimentalStatusTags } from 'bundles/product-card/components/utils/copyTestUtils';

export const getStatusTagRedesignExperimentVariant = (): {
  statusTagRedesignVariant: 'control' | 'A';
  productCardExperimentVariant: ProductCardProps['experimentVariant'];
} => {
  const isRolloutRunning = shouldUseExperimentalStatusTags();
  const showRedesignedCard = isRolloutRunning ? GrowthDiscoveryEpicClient.preview('productCardPills4b') : false;
  const productCardExperimentVariant: ProductCardProps['experimentVariant'] = showRedesignedCard
    ? 'test1.3'
    : 'control';
  return { statusTagRedesignVariant: showRedesignedCard ? 'A' : 'control', productCardExperimentVariant };
};

export const makeImpressionInStatusTagRedesignIfShould = () => {
  if (shouldUseExperimentalStatusTags()) {
    GrowthDiscoveryEpicClient.get('productCardPills4b');
  }
};
